import { useEffect } from 'react'

import { getSocketSetupComplete } from 'conversations/modules/socket/selectors'
import { getCurrentUser } from 'conversations/modules/user/selectors'
import { useDispatch, useSelector } from 'react-redux'
import { Dispatch } from 'redux'
import { receivedPingPongEndUserPresence } from 'shared/store/actions/endUser'
import { EndUser } from 'shared/typings/endUser/EndUser'
import { PresenceUpdatePayload } from 'shared/typings/endUser/Presence'
import { User } from 'shared/typings/user/User'
import { getUserIdTypeNumber } from 'shared/typings/UserIdType'

import { UserTypeIF } from '@driftt/app-config/dist/utils/driftTypes'
import { getDriftWebSocket } from '@driftt/drift-ws'

import { RootAction, RootState } from 'typesafe-actions'

export const usePresenceSubscription = (endUser: EndUser | undefined) => {
  const socketSetupComplete = useSelector<RootState, boolean>(getSocketSetupComplete)
  const dispatch = useDispatch<Dispatch<RootAction>>()

  const currentUser = useSelector<RootState, User | undefined>(getCurrentUser)
  const orgId = currentUser?.orgId ?? 0

  useEffect(() => {
    if (socketSetupComplete && endUser) {
      const ws = getDriftWebSocket()

      const newPresenceSub = ws
        .on<PresenceUpdatePayload>({
          cluster: 'chat',
          channelName: `user_presence:${orgId}-${endUser.id}-${getUserIdTypeNumber(
            endUser.type as UserTypeIF
          )}`,
          messageName: 'presence:update',
        })
        .subscribe((msg) => dispatch(receivedPingPongEndUserPresence({ ...msg, id: endUser.id })))

      return () => {
        newPresenceSub.unsubscribe()
      }
    }
  }, [socketSetupComplete, orgId, endUser, dispatch])
}
